import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetEmployeeState, getEmployee } from "../../../store/employee/action";
import { resetPayrateState, getPayrate as onGetPayrates, addNewPayrate as onAddNewPayrate, updatePayrate as onUpdatePayrate, deletePayrate as onDeletePayrate, getPayrateLoading, getPayrate } from "../../../store/payrate/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const Payrate = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, companies, companyLoading, payrates, isPayrateCreated, isPayrateSuccess, loading, error, employees, employeeLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    payrates: state.Payrate.payrates,
    isPayrateCreated: state.Payrate.isPayrateCreated,
    isPayrateSuccess: state.Payrate.isPayrateSuccess,
    loading: state.Payrate.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Payrate.error,
  }));

  const [payrateList, setPayrateList] = useState([]);
  const [payrate, setPayrate] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [printDoc, setPrintDoc] = useState([]);

  const [statusActive, setStatusActive] = useState([]);
  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];
  const onClickDelete = (payrate) => {
    setPayrate(payrate);
    setDeleteModal(true);
  };

  const handleDeletePayrate = () => {
    if (payrate) {
      dispatch(onDeletePayrate(payrate));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(payrates)) {
      let filteredPayrates = payrates;
      if (activeTypeTab !== "all") {
        filteredPayrates = payrates.filter((payrate) => payrate.payrate_status.name === activeTypeTab);
      }
      setPayrateList(filteredPayrates.map((el) => ({ ...el, isChecked: false })));
    }
  }, [payrates]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "payrate_user",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "rates",
        label: "Tarif",
        isSelected: true,
        data: [],
      },
      {
        id: "reason",
        label: "Kontrak",
        isSelected: true,
        data: [],
      },
      {
        id: "startat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (payrateList.length > 0) {
      payrateList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "payrate_user") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "rates") {
                doc.data.push(currencyFormat(value ?? "-"));
              } else if (doc.id === "startat") {
                doc.data.push(handleValidDate(value ?? "-"));
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [payrateList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPayrates = payrates;
      if (type !== "all") {
        filteredPayrates = payrates.filter((payrate) => payrate.payrate_status.name === type);
      }
      setPayrateList(filteredPayrates);
    }
  };

  useEffect(() => {
    if (companySelected && companySelected.value) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetPayrateState());
      dispatch(onGetPayrates({ companyId: companySelected?.value ?? "" }));
      handleGetEmployee(userData?.companyId);
    }
  }, [companySelected]);

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const userId = item.userId;
      var obj = { label: name, value: id, userId: userId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPayrate(null);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const handlePayrateClick = useCallback(
    (arg) => {
      const data = arg;

      setPayrate({
        id: data.id,
        description: data.description,
        startat: data.startat,
        reason: data.reason,
        employee: data.payrate_user && {
          label: data.payrate_user ? data.payrate_user.name : "",
          value: data.payrate_user ? data.payrate_user.id : "",
          userId: data.payrate_user ? data.payrate_user.id : "",
        },
        company: data.payrate_company && {
          label: data.payrate_company ? data.payrate_company.name : "",
          value: data.payrate_company ? data.payrate_company.id : "",
        },
        client: data.contract_client && {
          label: data.payrate_client ? data.payrate_client.name : "",
          value: data.payrate_client ? data.payrate_client.id : "",
        },
        rates: data.rates,
      });

      setIsEdit(true);
      toggle();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggle, userType]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePayrate(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setPayrate(employee);
    setApproveModal(true);
  };

  const handleApproveEmployee = () => {
    if (payrate) {
      payrate.setApprove = true;
      dispatch(onUpdatePayrate(payrate));
      dispatch(resetPayrateState());
      dispatch(onGetPayrates());
      setApproveModal(false);
    }
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }
  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = payrateList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPayrateList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = payrateList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setPayrateList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePayrate") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePayrateClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePayrate") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approvePayrate") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui tarif gaji untuk ${data.payrate_user.name}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "payrate_user.name",
        filterable: true,
      },
      {
        Header: "Tarif",
        accessor: "rates",
        filterable: true,
        Cell: (rates) => <> {currencyFormat(rates.row.original.rates)} </>,
      },
      {
        Header: "Kontrak",
        accessor: "reason",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Tanggal",
        accessor: "startat",
        filterable: true,
        Cell: (rates) => <> {handleValidDate(rates.row.original.startat)} </>,
      },
      {
        Header: "Status",
        accessor: "payrate_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [payrateList, handlePayrateClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format("HH:mm");
  };

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = payrateList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPayrateList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => payrateList, [payrateList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var reason = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      reason: reason,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPayrates(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPayrateList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetPayrateState());
    dispatch(onGetPayrates({ companyId: companySelected?.value ?? "" }));
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description: (payrate && payrate.description) ?? "",
      reason: (payrate && payrate.reason) ?? "",
      startat: (payrate && payrate.startat) ?? "",
      client: (payrate && payrate.client) || clientSelected,
      company: (payrate && payrate.company) || companySelected,
      employee: (payrate && payrate.employee) ?? "",
      rates: (payrate && payrate.rates) ?? "",
    },
    validationSchema: Yup.object({
      reason: Yup.string().required("Please Pick Reason"),
      rates: Yup.string().required("Please Enter Rate"),
      employee: Yup.object().required("Please Pick employee"),
      startat: Yup.string().required("Please Pick Effective Date"),
    }),
    onSubmit: (values) => {
      dispatch(getPayrateLoading());
      if (isEdit) {
        const updatePayrate = {
          id: payrate ? payrate.id : 0,
          statusId: 1,
          description: values.description,
          reason: values.reason,
          startat: values.startat,
          rates: values.rates,
          userId: values.employee.userId,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdatePayrate(updatePayrate));
        validation.resetForm();
      } else {
        const newPayrate = {
          statusId: 1,
          description: values.description,
          reason: values.reason,
          startat: values.startat,
          rates: values.rates,
          userId: values.employee.userId,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewPayrate(newPayrate));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "Tarif Gaji | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={payrateList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePayrate} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={payrate && payrate.payrate_employee ? payrate.payrate_employee.name + " - " + payrate.rates : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Karyawan" pageTitle="Tarif Gaji" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPayrate") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-user-unfollow-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={printDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deletePayrate") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="payrateList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-user-unfollow-line me-1 align-bottom fs-14"></i>SEMUA TARIF GAJI
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Tarif Gaji" : "Tambah Tarif Gaji"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp;
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  validation.setFieldValue("client", e);
                                }}
                                options={clientList}
                              ></Select>
                            </div>

                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp;
                                {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(null));
                                  dispatch(setCompanySelect(e));
                                  validation.setFieldValue("company", e);
                                }}
                                options={companyList}
                              ></Select>
                            </div>

                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="employee-field" className="form-label">
                                Karyawan <span className="text-danger">*</span>&nbsp;
                                {employeeLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}
                              </Label>
                              <Select
                                name="employee"
                                value={validation.values.employee}
                                placeholder="Pilih Karyawan"
                                onChange={(e) => {
                                  validation.setFieldValue("employee", e);
                                  // handleGetPosition(e.userId);
                                  // handleGetEmployee(e.value);
                                }}
                                options={employeeList}
                              ></Select>
                              {validation.touched.employee && validation.errors.employee ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.employee}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="reason-field" className="form-label">
                                Tarif
                              </Label>
                              <Input name="rates" id="rates-field" className="form-control" placeholder="Isi Tarif" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.rates ?? ""} invalid={validation.touched.rates && validation.errors.rates ? true : false} />
                              {validation.touched.rates && validation.errors.rates ? <FormFeedback type="invalid">{validation.errors.rates}</FormFeedback> : null}
                            </div>

                            <div className="mb-3 col-lg-3">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Berlaku
                              </Label>
                              <Flatpickr
                                name="startat"
                                className="form-control"
                                placeholder="Pilih Tanggal"
                                options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                value={validation.values.startat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("startat", e);
                                }}
                              />
                              {validation.touched.startat && validation.errors.startat ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.startat}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="reason-field" className="form-label">
                              Alasan
                            </Label>
                            <Input name="reason" id="reason-field" className="form-control" placeholder="Isi Alasan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.reason ?? ""} invalid={validation.touched.reason && validation.errors.reason ? true : false} />
                            {validation.touched.reason && validation.errors.reason ? <FormFeedback type="invalid">{validation.errors.reason}</FormFeedback> : null}
                          </div>
                          <div className="mb-4">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="reason">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Payrate;
